<template>
  <a-card :bordered="false">
    <a-divider orientation="left">
      <b>{{ $t('废品服务.扔垃圾服务配置') }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('废品服务.服务名称')" prop="serviceName">
        <a-input v-model="form.serviceName" :maxLength="128" :placeholder="$t('通用.输入.请输入')+$t('废品服务.服务名称')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('废品服务.服务说明')" prop="serviceIntro">
        <a-textarea v-model="form.serviceIntro" :rows="3" :maxLength="500" />
      </a-form-model-item>

      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item :label="$t('废品服务.服务封面图')" prop="picture">
            <OssUploadSingle v-model="form.picture" type="img" :maxSize="200" prefix="waste"></OssUploadSingle>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('废品服务.服务价格')" prop="price">
            <a-input-number v-model="form.price" :min="0" :precision="2" style="width: 100%" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-form-model-item :label="$t('废品服务.服务介绍')" prop="imgList">
        <OssUploadMulti v-if="pageReady" v-model="form.imgList" :isArrayData="true" :max-count="9" prefix="waste" type="img"></OssUploadMulti>
      </a-form-model-item>

      <a-form-model-item :label="$t('废品服务.服务标准')" prop="serviceStandard">
        <a-textarea v-model="form.serviceStandard" :rows="4" :maxLength="1000" />
      </a-form-model-item>

      <a-form-model-item :label="$t('废品服务.备注')" prop="remark">
        <a-textarea v-model="form.remark" :rows="2" :maxLength="500" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">{{ $t('通用.按钮.保存') }}</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-card>
</template>

<script>
import { getGarbageService, saveGarbageService } from '@/api/homewaste/waste'
import OssUploadSingle from '@/components/OssUploadSingle'
import OssUploadMulti from '@/components/OssUploadMulti'

export default {
  name: 'GarbageService',
  components: { OssUploadSingle, OssUploadMulti },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      submitLoading: false,
      pageReady: false,
      form: {
        serviceName: null,
        serviceIntro: null,
        imgList: [],
        serviceStandard: null,
        picture: null,
        price: null,
        remark: null
      },
      rules: {
        serviceName: [{ required: true, message: this.$t('废品服务.服务名称') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        picture: [{ required: true, message: this.$t('废品服务.服务封面图') + this.$t('通用.文本.不能为空'), trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      getGarbageService().then(response => {
        if (response.data) {
          const data = response.data
          // 处理多图：后端返回数组格式
          let imgList = []
          if (data.imgList) {
            if (Array.isArray(data.imgList)) {
              imgList = data.imgList
            } else if (typeof data.imgList === 'string') {
              imgList = data.imgList.split(',').filter(url => url)
            }
          }
          this.form = {
            ...data,
            imgList: imgList
          }
        }
        // 数据准备完成后，再渲染组件
        this.$nextTick(() => {
          this.pageReady = true
        })
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const submitData = {
            ...this.form,
            imgList: this.form.imgList && this.form.imgList.length > 0 ? this.form.imgList.join(',') : null
          }
          saveGarbageService(submitData).then(() => {
            this.$message.success(this.$t('通用.文本.修改成功'))
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>
